import { render } from "./UmsStatus.vue?vue&type=template&id=a0a6b362"
import script from "./UmsStatus.vue?vue&type=script&lang=js"
export * from "./UmsStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__